<div class="create">
  <h2 mat-dialog-title>{{ data?.id ? 'Edit' : 'Create' }}</h2>
  <mat-dialog-content>
    <form [formGroup]="form" (ngSubmit)="save()">
      <mat-form-field>
        <mat-label>Permission group name</mat-label>
        <input matInput formControlName="label" />
        <mat-error *ngIf="form.get('label').hasError('required')">
          Permission group name is <strong>required</strong>
        </mat-error>
        <mat-error *ngIf="form.get('label').hasError('minlength')">
          Permission group name is too short (minimum is 3 characters)
        </mat-error>
      </mat-form-field>
    </form>
  </mat-dialog-content>
  <mat-dialog-actions align="end">
    <button mat-button mat-dialog-close>Cancel</button>
    <button mat-flat-button color="primary" [disabled]="!form.valid" (click)="save()">Save</button>
  </mat-dialog-actions>
</div>
